var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.brokenWord),function(word,index){return [_vm._v(_vm._s(word)),_c('wbr',{key:index})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }